export default __webpack_public_path__ + "static/media/InfoActive.26ddadf5.svg";